export const success = [
    {
        id: 1,
        src:require('@/assets/img/successcases1.png'),
        name: '丹阳邮政'
    },
    {
        id: 2,
        src:require('@/assets/img/successcases2.png'),
        name: '湘潭中通、丰网'
    },
    {
        id: 3,
        src:require('@/assets/img/successcases3.png'),
        name: '淮北申通、丰网'
    },
    {
        id: 4,
        src:require('@/assets/img/successcases4.png'),
        name: '海门共配中心'
    },
    {
        id: 5,
        src:require('@/assets/img/successcases5.png'),
        name: '灌南京东云仓'
    },
    {
        id: 6,
        src:require('@/assets/img/successcases6.png'),
        name: '宿迁极兔'
    },
]